import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import RolleListe from './rolleliste.psa';
import BestillingerPage from './bestillingsliste.psa';
import Fordeling from './fordeling/fordeling.psa';
import translation from './activity.psa.i18n';
import Detaljer from './detaljer.psa';
import { Tab, Tabs } from '../components/tabs/tabs';
import { PageNotFoundWithoutLayout } from '../pages/pagenotfound';
import { useFormatMessageFor } from '../i18n/translation';

export enum ActivityTab {
  DETALJER = 'detaljer',
  STEDER = 'steder',
  ROLLER = 'roller',
  FORDELING = 'fordeling',
}

const ActivityTabs = () => {
  const labels = useFormatMessageFor(translation);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Tabs>
              {Object.values(ActivityTab).map((tabName) => (
                <Tab key={tabName} to={`../${tabName}`} id={tabName}>
                  {labels[tabName]}
                </Tab>
              ))}
            </Tabs>
            <Outlet />
          </>
        }
      >
        <Route path="" element={<Navigate to="detaljer" replace />} />
        <Route path="detaljer" element={<Detaljer />} />
        <Route path="steder" element={<BestillingerPage />} />
        <Route path="roller" element={<RolleListe />} />
        <Route path="fordeling" element={<Fordeling />} />
        <Route path="*" element={<PageNotFoundWithoutLayout />} />
      </Route>
    </Routes>
  );
};

export default ActivityTabs;
